import { useBondsBondFieldApi } from '../api';

export const useBondsBondSIssuerName1 = () => {
  const response = useBondsBondFieldApi('S_ISSUER.NAME_1');
  return response;
};
